import { useDisclosure } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelAvaliacaoAtendimento = () => {
  const [searchParams] = useSearchParams();
  const state = useLocation();
  const agenda_exames_id = state?.state?.agenda_exames_id;
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAva, setLoadingAva] = useState(false);
  const [error, setError] = useState(false);
  const [rating, setRating] = useState(0);
  const [opnion, setOpnion] = useState();
  const [agendamento, setAgendamento] = useState(null);
  const navigate = useNavigate();
  const { user, setUser } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const assinante = userIsSubscriber(user);
  const modalSuporte = useDisclosure();
  const [liberarDashboard, setLiberarDashboard] = useState(false);
  const modalAvaliacaoLoja = useDisclosure();

  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }

    if (/android/i.test(userAgent)) {
      return 'android';
    }

    return 'web';
  };

  const device = searchParams.get('platform') ?? detectDevice();

  async function avaliacaoAtendimento() {
    setError(false);
    setLoadingAva(true);
    const url = ENDPOINT + '/schedule/rating';
    const payload = [
      {
        agenda_exames_id: parseInt(agenda_exames_id),
        medico_id: parseInt(agendamento.medicoid),
        opiniao: opnion === undefined ? '' : opnion,
        avaliacao: rating,
      },
    ];

    const options = {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify(payload),
    };
    try {
      const res = await api(url, options);
      if (!res || !res.ok || res.status >= 400) {
        setError(true);
        setLoadingAva(false);
        setRedirect(false);
      } else {
        const data = (await res.json())[0];
        console.log('data ', data);
        if (data.success) {
          setRedirect(false);
          setLoadingAva(false);
          setUser((prevState) => ({
            ...prevState,
            avaliacao_pendente: false,
          }));
          if (assinante && rating >= 4) {
            await validaAvaliacaoLoja();
            return;
          }
          console.log('data ', data);
          navigate('/dashboard');
          return;
        } else {
          if (data?.data?.error === 'Avaliação já realizada') {
            setError(false);
            setRedirect(false);
            setLoadingAva(false);
            setUser((prevState) => ({
              ...prevState,
              avaliacao_pendente: false,
            }));
            navigate('/dashboard');
            return;
          }
          setError(true);
          setRedirect(false);
          setLoading(false);
        }
      }
    } catch (error) {
      setError(true);
      setRedirect(false);
      setLoadingAva(false);
    }
  }

  async function searchDadosAgendamento() {
    try {
      setError(false);
      setLoading(true);
      await api(`${ENDPOINT}/clients/searchDadosAgendamento`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ agenda_exames_id }),
      })
        .then(async (res) => {
          if (!res || !res.ok || res.status >= 400) {
            setError(true);
            setLoading(false);
            return;
          }
          return await res.json();
        })
        .then(async (resposta) => {
          if (resposta !== null) {
            setRedirect(true);
            setError(false);
            setLoading(false);
            setAgendamento(resposta);
          }
        });
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  }

  async function validaAvaliacaoLoja() {
    try {
      await api(`${ENDPOINT}/clients/avaliacaoLoja`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ agenda_exames_id, origem: 'pos_telemedicina', plataforma: user.device }),
      })
        .then(async (res) => {
          if (!res || !res.ok || res.status >= 400) {
            setError(true);
            setLoading(false);
            return;
          }
          return await res.json();
        })
        .then(async (resposta) => {
          console.log('resposta ', resposta);
          if (resposta.avaliacao) {
            modalAvaliacaoLoja.onOpen();
          }
          navigate('/dashboard');
          return;
        });
    } catch (error) {
      setLiberarDashboard(true);
    } finally {
      setLiberarDashboard(true);
    }
  }

  useEffect(() => {
    if (!redirect) return;
    return;
    const timeout = setInterval(() => {
      navigate('/dashboard');
    }, 30 * 1000);
    return () => {
      if (timeout) clearInterval(timeout);
    };
  }, [redirect, error]);

  useEffect(() => {
    searchDadosAgendamento();
  }, []);

  return {
    avaliacaoAtendimento,
    error,
    loading,
    theme,
    rating,
    setRating,
    opnion,
    setOpnion,
    assinante,
    modalSuporte,
    navigate,
    agendamento,
    loadingAva,
    liberarDashboard,
    modalAvaliacaoLoja,
    agenda_exames_id,
  };
};

export default useModelAvaliacaoAtendimento;
